import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, of, switchMap } from 'rxjs';
import * as AppSettingsActions from './app-settings.actions';

@Injectable()
export class AppSettingsEffects {
  private actions$ = inject(Actions);

  init$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AppSettingsActions.initAppSettings),
      switchMap(() =>
        of(
          AppSettingsActions.loadAppSettingsSuccess({
            appSettings: {
              loaded: true,
              headerText: 'Dashboard',
              currentUrl: '/dashboard',
            },
          })
        )
      ),
      catchError((error) => {
        // console.error('Error', error);
        return of(AppSettingsActions.loadAppSettingsFailure({ error }));
      })
    )
  );
}
